class QuickAdd extends HTMLElement {
    
  // >>> constructor ============
  constructor() {
   super();    
    this.quickadd = this; 
    this.addBtn = this.querySelector('button');
    this.pid = Number(this.addBtn.dataset.pid);
    this.qty = Number(this.addBtn.dataset.qty) || 1;    
    this.sku = this.addBtn.dataset.sku;
    this.title = this.addBtn.dataset.title;
    this.price = this.addBtn.dataset.price;   
    this.property = this.addBtn.dataset.property;  

    this.cartFunctions = new CartFunctions();  
    this.cartBubble = document.querySelector('.cart-count-bubble span');
    this.clickEvent(this.qty);
    this.loadEvent();
  }
         
  // Temp fix: on load den fortone sto url to variant id
  loadEvent() {
    this.pid = Number(this.addBtn.dataset.pid);
    if(!window.location.href.includes(this.pid)) {     
      window.history.replaceState({ }, '', `${window.location.href}?variant=${this.pid}`);
    } 
  }

  
  clickEvent() {    
    // this.addBtn.addEventListener('click', (e) => {
    //   this.pid = Number(this.addBtn.dataset.pid);            
    //   const itemsToBeDeleted = document.querySelectorAll('.ajax-cart-product-area');

    //   this.stock = this.addBtn.dataset.stock;           
    //   this.policy = this.addBtn.dataset.policy;

    //   //let mfg = document.querySelector('#cart-item-template');

    //   itemsToBeDeleted.innerHTML = ' ';
    //   e.preventDefault();
      
    //   if(typeof(this.pid) == 'number' && this.pid !== 'undefined' && this.pid !== ''){ 
    //     (async () => {              
    //       const addProduct = await this.cartFunctions.addItem(this.pid, Number(this.addBtn.dataset.qty));	                             
    //       const changeCartBuble = await this.cartFunctions.getCart();
    //       let bubbleTotal = changeCartBuble.item_count;
    //       this.cartBubble.textContent = bubbleTotal;        
    //       let openCartDrawer = document.querySelector('.cartToggler');
    //       openCartDrawer.click();                                                              
    //     })()
        
        
    //     glami('track', 'AddToCart', {
    //       consent: 1,
    //       item_ids: [`${this.sku}`], 
    //       product_names: [`${this.title}`], 
    //       value: this.price,
    //       currency: 'EUR' 
    //     });
      
    //   }
    // })    

    this.addBtn.addEventListener('click', (e) => {

      this.pid = Number(this.addBtn.dataset.pid);            
      const itemsToBeDeleted = document.querySelectorAll('.ajax-cart-product-area');

      this.stock = this.addBtn.dataset.stock;           
      this.policy = this.addBtn.dataset.policy;
      itemsToBeDeleted.innerHTML = ' ';
      
      e.preventDefault();

      const recipientForm = document.querySelector('recipient-form');
      if (recipientForm) {
        const sectionId = recipientForm.dataset.sectionId;
        const giftCardCheckbox = recipientForm.querySelector(`#Recipient-checkbox-${sectionId}`);
        
        // Only validate if the gift option is checked.
        if (giftCardCheckbox && giftCardCheckbox.checked) {
          // Gather all input and textarea elements within the recipient form.
          const fields = recipientForm.querySelectorAll('input, textarea');
          let allValid = true;
          fields.forEach(field => {
            // If a field fails validation, report its validity and mark the form as invalid.
            if (!field.checkValidity()) {
              field.reportValidity();
              allValid = false;
            }
          });
          
          // If one or more fields are invalid, stop the add-to-cart process.
          if (!allValid) {
            return;
          }
        }
      }
    
    let giftCardProperties = {};
    if (recipientForm) {
      const sectionId = recipientForm.dataset.sectionId;
      const giftCardCheckbox = recipientForm.querySelector(`#Recipient-checkbox-${sectionId}`);
      if (giftCardCheckbox && giftCardCheckbox.checked) {
        giftCardProperties = {
          'Recipient email': recipientForm.querySelector(`#Recipient-email-${sectionId}`)?.value || '',
          'Recipient name': recipientForm.querySelector(`#Recipient-name-${sectionId}`)?.value || '',
          'Message': recipientForm.querySelector(`#Recipient-message-${sectionId}`)?.value || '',
          'Send on': recipientForm.querySelector(`#Recipient-send-on-${sectionId}`)?.value || ''
        };
      }
    }
    
      (async () => {
        const addProduct = await this.cartFunctions.addItemWithProperties(this.pid, Number(this.addBtn.dataset.qty), giftCardProperties);	                             
        const cartData = await this.cartFunctions.getCart();
        let bubbleTotal = cartData.item_count;
        this.cartBubble.textContent = bubbleTotal;
        const openCartDrawer = document.querySelector('.cartToggler');
        openCartDrawer.click();
      })();
    
      // glami('track', 'AddToCart', {
      //   consent: 1,
      //   item_ids: [`${this.sku}`], 
      //   product_names: [`${this.title}`], 
      //   value: this.price,
      //   currency: 'EUR' 
      // });
    });
  }
       
}
customElements.define('quickadd-component', QuickAdd); 